/// <reference path="../_all.ts" />

module glossar {

  GlossarEntryDirective.$inject = [
    '$mdDialog',
    '$http',
    '$compile',
    '$timeout',
  ];

  export function GlossarEntryDirective(
                    $mdDialog: ng.material.IDialogService,
                    $http: ng.IHttpService,
                    $compile: ng.ICompileService,
                    $timeout: ng.ITimeoutService,
                  ): ng.IDirective {

    return {
      restrict: 'A',
      transclude: true,
      scope: {
        entry : '=',
      },
      link: function (scope: IGlossarEntryDirectiveScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, c: ng.IController, transclude: ng.ITranscludeFunction) {
        $http<string>({
          method: "GET"
          , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Glossary/Entry?Id=" + scope.entry.GlossaryID
          , headers: { 'Content-Type': 'application/json' }
          , params: { }
          , data: {
          }
        }).then( (response : { data: string }) => {
          element.append($compile(response.data)(scope));
          //scope.entry.Active = !scope.entry.Active;
          $timeout(() => {
            (<any>window).MathJax.Hub.Queue(["Typeset", (<any>window).MathJax.Hub, element[0]]);
          }, 0);                
        });
      }
    }

  }

}